import type {ReactAction} from '@netx/core/bootstrap';
import {faBolt} from '@fortawesome/pro-solid-svg-icons';
import {currentCartIsNotEmpty} from '../enablers';
import {UserCustomAction} from '@netx/core-custom-action/types';

export type CartActionCustomParams = Required<Pick<ReactAction, 'cb'>> &
	Partial<Omit<ReactAction, 'cb'>>;

/**
 * Custom cart action
 * @param params
 * @returns Action
 */
export const cartActionCustom = (
	customAction: UserCustomAction,
	params: CartActionCustomParams,
): ReactAction => ({
	name: `custom-action-${customAction.customActionId}`,
	enableTest: currentCartIsNotEmpty,
	icon: faBolt,
	get label() {
		return customAction.name;
	},
	...params,
});

export default cartActionCustom;
